import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageTitle } from "../hooks/usePageTitle";
import { useLanguage } from "../lib/LanguageContext";
import Breadcrumb from "../components/Breadcrumb";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  const { language } = useLanguage();
  const isPl = language === "pl";

  usePageTitle(
    isPl ? "Kontakt — TerpeneAtlas" : "Contact — TerpeneAtlas",
    isPl
      ? "Skontaktuj się z zespołem TerpeneAtlas."
      : "Get in touch with the TerpeneAtlas team."
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-6 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        {isPl ? "Powrót do strony głównej" : "Back to Home"}
      </Link>

      <Breadcrumb
        items={[
          { label: isPl ? "Strona główna" : "Home", to: "/" },
          { label: isPl ? "Kontakt" : "Contact" },
        ]}
      />

      <h1 className="text-3xl md:text-4xl font-playfair font-bold mb-6 text-center">
        {isPl ? "Kontakt" : "Contact"}
      </h1>

      <div className="bg-card rounded-xl border border-border p-6 space-y-4 text-sm text-muted-foreground leading-relaxed">
        <p>
          {isPl
            ? "Masz pytanie dotyczące strony, sugestię dotyczącą nowej odmiany lub chcesz zgłosić błąd?"
            : "Do you have a question about the app, a suggestion regarding a new strain, or want to report an error?"}
        </p>
        <p>
          {isPl
            ? "Napisz do mnie przez poniższy formularz lub na maila admin@terpeneatlas.org - na pewno odpowiem!"
            : "Write to me using the form below or at admin@terpeneatlas.org - I'll do my best to answer all your questions."}
        </p>

        <div className="mt-4">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}